import script from "./AdminPrivacy.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPrivacy.vue?vue&type=script&setup=true&lang=js"

import "./AdminPrivacy.vue?vue&type=style&index=0&id=2be58e3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be58e3d"]])

export default __exports__